import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["UiSortMenu"], {
    items: $setup.items,
    "model-value": $setup.props.modelValue,
    fixmobile: "",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('update:modelValue', $event)))
  }, null, 8 /* PROPS */, ["items", "model-value"]))
}